import { setStoreValue } from "@/store/utils";

export const SET_IS_FETCHING_USER_LANGUAGES = "SET_IS_FETCHING_USER_LANGUAGES";
export const SET_CURRENT_USER_LANGUAGES = "SET_CURRENT_USER_LANGUAGES";
export const SET_IS_FETCHING_ALL_LANGUAGES = "SET_IS_FETCHING_ALL_LANGUAGES";
export const SET_ALL_LANGUAGES = "SET_ALL_LANGUAGES";
export const SET_ALL_SKILLS = "SET_ALL_SKILLS";
export const SET_IS_FETCHING_LANGUAGE_LEVELS =
  "SET_IS_FETCHING_LANGUAGE_LEVELS";
export const SET_LANGUAGE_LEVELS = "SET_LANGUAGE_LEVELS";
export const SET_IS_FETCHING_ALL_SKILLS = "SET_IS_FETCHING_ALL_SKILLS";
export const SET_IS_FETCHING_SKILL_LEVELS = "SET_IS_FETCHING_SKILL_LEVELS";
export const SET_SKILL_LEVELS = "SET_SKILL_LEVELS";
export const SET_CURRENT_USER_SKILLS = "SET_CURRENT_USER_SKILLS";
export const SET_IS_FETCHING_USER_SKILLS = "SET_IS_FETCHING_USER_SKILLS";

const mutations = {
  [SET_IS_FETCHING_USER_LANGUAGES]: setStoreValue("isFetchingUserLanguages"),
  [SET_CURRENT_USER_LANGUAGES]: setStoreValue("currentUserLanguages"),
  [SET_IS_FETCHING_ALL_LANGUAGES]: setStoreValue("isFetchingAllLanguages"),
  [SET_IS_FETCHING_ALL_SKILLS]: setStoreValue("isFetchingAllSkills"),
  [SET_ALL_LANGUAGES]: setStoreValue("allLanguages"),
  [SET_ALL_SKILLS]: setStoreValue("allSkills"),
  [SET_IS_FETCHING_LANGUAGE_LEVELS]: setStoreValue("isFetchingLanguageLevels"),
  [SET_LANGUAGE_LEVELS]: setStoreValue("languageLevels"),
  [SET_IS_FETCHING_SKILL_LEVELS]: setStoreValue("isFetchingSkillLevels"),
  [SET_SKILL_LEVELS]: setStoreValue("skillLevels"),
  [SET_CURRENT_USER_SKILLS]: setStoreValue("currentUserSkills"),
  [SET_IS_FETCHING_USER_SKILLS]: setStoreValue("isFetchingUserSkills")
};

const state = {
  allSkills: [],
  allLanguages: [],
  isFetchingAllLanguages: false,
  currentUserLanguages: [],
  isFetchingUserLanguages: false,
  allLevels: [],
  isFetchingLanguageLevels: false,
  languageLevels: [],
  isFetchingAllSkills: false,
  isFetchingSkillLevels: false,
  skillLevels: [],
  currentUserSkills: [],
  isFetchingUserSkills: false
};

export { mutations, state };
